/*
 * log levels in order of severity:
 * error, warn, info, verbose, debug, silly
 *
 * process.env.NODE_ENV is injected at build time by webpack DefinePlugin:
 *   production builds → 'production'  (console.log calls dead-code eliminated)
 *   dev / apdev builds → 'development' (logging enabled)
 */

function log(level, args) {
    if (level == 'error') {
        console.error(`[${new Date().toISOString()}: ${level}]: `, ...args);
    } else if (level == 'warn') {
        console.warn(`[${new Date().toISOString()}: ${level}]: `, ...args);
    } else {
        if (process.env.NODE_ENV !== 'production') {
            console.log(`[${new Date().toISOString()}: ${level}]: `, ...args);
        }
    }
}

/*
window.myDebug = console.log.bind(window.console, '%s: %s'); // Log with a custom prefix
//    window.debug = console.log.bind(window.console, '%s: %s'); // Log with a custom prefix
export const Logger = {
    silly: (...args) => { log('silly', args); },
    debug: (...args) => { log('debug', args); },
    verbose: (...args) => { log('verbose', args); },
    info: (...args) => { log('info', args); },
    warn: (...args) => { log('warn', args); },
    error: (...args) => { log('error', args); },
    test: window.myDebug
}
*/

//
// public functions
//
export function silly(...args) { log('silly', args); }
export function debug(...args) { log('debug', args); }
export function verbose(...args) { log('verbose', args); }
export function info(...args) { log('info', args); }
export function warn(...args) { log('warn', args); }
export function error(...args) { log('error', args); }
